import React from 'react';
import { motion } from 'framer-motion';
export function PricingCTA() {
  return <section className="py-4 px-4 md:px-8" data-id="element-185">
      <div className="max-w-4xl mx-auto text-center" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-187">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-[#F5A623] text-white px-8 py-3 rounded-full font-bold shadow-lg hover:shadow-xl transition-all cursor-pointer text-[13px]" data-id="element-188">
            💝 QUIERO ESTE REGALO PARA MAMÁ →
          </motion.button>

          <div className="flex flex-wrap justify-center items-center gap-1 mt-3" data-id="element-189">
            <span className="text-[#F5A623] text-xs" data-id="element-190">★★★★★</span>
            <span className="text-[10px] text-[#030303]" data-id="element-191">
              4.9/5 · +480 familias · Acceso inmediato al email
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mt-2" data-id="element-192">
            <span className="text-[10px] text-[#060606]" data-id="element-193">
              📥 Acceso inmediato
            </span>
            <span className="text-[10px] text-[#050505]" data-id="element-194">
              🎁 4 bonos incluidos
            </span>
            <span className="text-[10px] text-[#030303]" data-id="element-195">
              ♾️ Tuyo para siempre
            </span>
            <span className="text-[10px] text-[#030303]" data-id="element-196">🔒 Compra segura</span>
          </div>
        </motion.div>
      </div>
    </section>;
}